export default __webpack_public_path__ + "static/media/eye.407c74c7.svg";